module.exports = __webpack_public_path__ + "static/media/newmsg2.85cadaaa.mp3";